import { Component, ViewChild, ElementRef, Input, AfterViewInit, Renderer2 } from "@angular/core";

@Component({
    selector: "app-expandable",
    templateUrl: "./expandable.component.html",
    styleUrls: ["./expandable.component.scss"],
    standalone: true,
})
export class ExpandableComponent implements AfterViewInit {
  @ViewChild("expandWrapper", { read: ElementRef, static: true }) expandWrapper: ElementRef;
  @Input() expanded: any;
  @Input() expandHeight: number;
  constructor(public renderer: Renderer2) {}

  ngAfterViewInit() {
    this.renderer.setStyle(this.expandWrapper.nativeElement, "height", this.expandHeight + "vh");
  }
}
